// extracted by mini-css-extract-plugin
export default {"wrapper":"_d","form":"ae","label":"be","asterisk":"ce","smallprint":"de","success":"ee","circle":"fe"};